<div [ngClass]="classList ? classList : ''" class="advertisement_units" >
    <div class="container">

        <!-- start units filter -->
        <ng-container *ngIf="IsBuilding">
            <div class="units_filter">
                <form [formGroup]="filterForm">
                    <div class="row">
                        <div class="col-12 col-md-3 mb-4">
                            <ng-select 
                                bindValue="range"
                                bindLabel="title"
                                [searchable]="false"
                                class="sm text-center"
                                formControlName="size"
                                placeholder="اختر المساحة"
                                [items]="listOfUnitsSizesRange"
                                (change)="floorsUnitsFilterFromTo()"
                            />
                        </div>
                        <div class="col-12 col-md-6 mb-4">
                            <ng-select 
                                bindValue="range"
                                bindLabel="title"
                                [searchable]="false"
                                class="sm text-center"
                                formControlName="price"
                                placeholder="اختر السعر"
                                [items]="listOfUnitsPricesRange"
                                (change)="floorsUnitsFilterFromTo()"
                            />
                        </div>
                        <div class="col-12 col-md-3 mb-4">
                            <ng-select 
                                bindValue="range"
                                bindLabel="title"
                                [searchable]="false"
                                class="sm text-center"
                                formControlName="roomsCount"
                                placeholder="اختر عدد الغرف"
                                [items]="listOfUnitsRoomsRange"
                                (change)="floorsUnitsFilterFromTo()"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </ng-container>
        <!-- end units filter -->

        <!-- start units -->
        <div class="row">

            <!-- start OffPlanSale title -->
            <ng-container *ngIf="IsOffPlanSale">
                <ng-container *ngIf="Units.length > 0; else UnitsEmpty">
                    <div class="col-12 mb-4">
                        <h3 class="unite_title text-center font_26 font_700 mb-0">
                            العمارات داخل المشروع
                        </h3>
                    </div>
                </ng-container>
                <ng-template #UnitsEmpty>
                    <h3 class="font_20 font_600 text-center text-danger">لا يوجد عمارات داخل المشروع</h3>
                </ng-template>
            </ng-container>
            <!-- end OffPlanSale title -->

            <ng-container *ngFor="let Unit of Units; let index = index; let last = last; let first = first">

                <!-- start OffPlanSale -->
                <ng-container *ngIf="_isOffPlanSaleAdvertisementBuildings(Unit)">
                    <div class="col-12 col-md-6 mb-4">
                        <app-advertisement-card [info]="$any(Unit)" />
                    </div>
                </ng-container>
                <!-- end OffPlanSale -->

                <!-- start Building -->
                <ng-container *ngIf="_isBuildingAdvertisementUnits(Unit)">

                    <!-- start floor title -->
                    <div class="col-12 mb-4">
                        <h3 class="unite_title font_26 font_700 mb-0 d-flex align-items-center justify-content-between">
                            <ng-container *ngIf="index <= 9; else otherFloors">
                                الدور {{floorsNumber[Unit.floor - 1]}}
                            </ng-container>
                            <ng-template #otherFloors>الدور ( {{Unit.floor}} )</ng-template>
                        </h3>
                    </div>
                    <!-- end floor title -->

                    <!-- start floor units -->
                    <ng-container *ngFor="let unit of Unit.unit; let last = last">
                        <div class="col-12 col-md-6 mb-4">
                            <app-advertisement-card [info]="$any(unit)" />
                        </div>
                    </ng-container>
                    <!-- end floor units -->
                     
                </ng-container>
                <!-- end Building -->

            </ng-container>

        </div>

        <ng-container *ngIf="Units.length == 0 && IsBuilding">
            <h3 class="font_20 font_600 text-center text-danger">لا يوجد وحدات بالمواصفات المطلوبة</h3>
        </ng-container>
        <!-- start units -->

    </div>
</div>